import { Segment } from '~src/interfaces/segment.interface';
import { Survey } from '~src/modules/surveys/interfaces';

import { ScheduleI } from './schedule.interface';
import { ContentLocalesI } from './session.types';

export enum PackName {
  SelfAssessment = 'self_assessment',
  Assessment = 'assessment',
  SelfSelection = 'self_selection',
  ManagersSelection = 'managers_selection',
  CustomSelector = 'custom_selector'
}

export function getPackNameTranslationKey(packName: PackName): string {
  return `x.interfaces.cycle.pack_name.${packName}`;
}

export interface PackI extends AnonPack {
  about: Segment;
}

export interface AnonPack {
  name: PackName;
  finished: boolean;
}

export interface CurrentPack {
  cycleId: string;
  packAbout?: string;
  packName: PackName;
}

export interface CycleI {
  id: string;
  startDate: string;
  survey: Survey;
  dueDate: string;
  remindDate: string;
  repetition: number;
  closed: boolean;
  schedule: ScheduleI;
  createdAt: string;
  packs: PackI[];
  pack: string;
  onRemove?: (cycle: CycleI) => void;
}

export interface ESCycle {
  anonymous: boolean;
  closed: boolean;
  due_date: string | null;
  id: string;
  schedule_id: string;
  start_date: string;
  survey_id: string;
}

export enum CycleStatus {
  Active = 'active',
  InActive = 'inactive',
  Scheduled = 'scheduled',
}

export interface CustomCycle {
  id: string;
  startDate: string;
  dueDate: string;
  cycleStatus: CycleStatus;
  remindDate?: string;
  repetition?: boolean;
  name?: ContentLocalesI;
}

export type NewCustomCycle = Omit<CustomCycle, 'id'>;

export function isCustomCycle(customCycle: CustomCycle|NewCustomCycle): customCycle is CustomCycle {
  return Boolean((customCycle as CustomCycle).id);
}

export enum StatusColor {
  Red = 'red',
  Green = 'green',
  Blue = 'blue',
  Yellow = 'yellow',
}
